import { render, staticRenderFns } from "./ReportFormHeader.vue?vue&type=template&id=2d63b66b&scoped=true"
import script from "./ReportFormHeader.vue?vue&type=script&lang=js"
export * from "./ReportFormHeader.vue?vue&type=script&lang=js"
import style0 from "./ReportFormHeader.vue?vue&type=style&index=0&id=2d63b66b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63b66b",
  null
  
)

export default component.exports